

import { EntityActions } from '../common/base/entity';
import jsonData from './validateEmail.json';
export class EmailSettingAction extends EntityActions {
 
  constructor(options) {
      super(options)
  }
	
	validateEmail(emailId){
		var name   = emailId.substring(0, emailId.lastIndexOf("@"));
		var domain = emailId.substring(emailId.lastIndexOf("@") +1);
			const filterData = jsonData.filter(row => row==domain);
			if(filterData.length>0){return true}else{return false}
		 
}
// 
  preActionsHooks({ actionName, item }) {
		if (!item || Object.keys(item).length === 0) return
		if (item && (actionName == 'addNewItem') || actionName == 'editItem' || actionName == 'publishItem') {
			let payload = { ...item } 
			if (!payload.status && actionName === 'publishItem') payload.status = 'Published'
			if(!item.supportEmail) item.supportEmail = 'system@rezolve.ai'
			let removeObjectProperties = function (obj, props) {
				for (var i = 0; i < props.length; i++) {
					if (obj.hasOwnProperty(props[i])) {
						delete obj[props[i]]
					}
				}
			}
      let properties = {
        supportEmail: item.supportEmail|| '',
				defaultEmailCC : item.defaultEmailCC || '',
				ignoreWatchers :  item.ignoreWatchers || '',
				fromEmailConfig : item.fromEmailConfig || '',
				watcherPlaceholder: item.watcherPlaceholder || '',
				replyToEmailConfig: item.replyToEmailConfig || '',
        replyTo: item.replyTo || '',
				OriginalSupportReplyTo: item.OriginalSupportReplyTo || '',
				queue: item.queue || ''
			}
			payload.properties = properties
			console.log(payload, 'payload')
			item = payload
			removeObjectProperties(item, [
				'supportEmail',
				'defaultEmailCC',
				'ignoreWatchers',
				'fromEmailConfig',
				'watcherPlaceholder',
				'replyToEmailConfig',
        'replyTo',
				'OriginalSupportReplyTo',
				'queue'
			])

			let emailAddress =this.validateEmail(payload.properties.supportEmail);
			if(emailAddress){
				// toast.error('Please Enter a valid business email')				
				return {
					error:{message : 'Please enter a valid business email'}
			}
			}
			return item
		} else {
			return item
		}
	}

	postActionsHooks({ actionName, item, tenantId }) {
		switch (actionName) {
			case 'getAll':
				let items =
					item &&
					item.map(i => {
						i = Object.assign({}, i, i.properties)
						i.supportEmail = i.properties.supportEmail
						i.replyTo = i.properties.replyTo  
						return i
					})
				return items
			case 'getOne':
				if(!item.properties) return item
				item = Object.assign({}, item, item.properties);   
				item.supportEmail = item.properties.supportEmail
				item.replyTo = item.properties.replyTo 
				return item
			default:
				if (item) {
					return {
						...item, 
						configType: ['defaultSetting'].includes(item.configType)? '': item.configType
					}
				} else {
					return item
				}
		}
	}
    

}
